var path = 'templates/transcription/notes.html';
var html = "<md-content style=height:100%> <p ng-if=!notes.length style=margin:auto;padding:10px>このコマにはまだノートがありません</p> <md-list class=md-dense> <md-list-item ng-repeat=\"n in notes | orderBy:'-timestamp'\" ng-init=\"user = users.get(n.uid)\"> <img ng-src={{user.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{user.name}}</h3> <p>{{n.text}}</p> <p>{{moment(n.timestamp).fromNow()}}</p> </div> </md-list-item> </md-list> </md-content> <md-button ng-click=addNote($event) class=md-fab style=position:absolute;bottom:15px;right:5px> <md-tooltip md-direction=top> ノートを追加</md-tooltip> <md-icon>note_add</md-icon> </md-button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/notes.html
// module id = 67
// module chunks = 0